module.exports = __webpack_public_path__ + "static-portal/img/22-1.700c163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/22-1.jpg
// module id = mVIN
// module chunks = 4